import React from 'react';
import { useFormatAddress } from 'hooks';

import EntityProfile from 'components/EntityPage/EntityProfile';
import entitySchema from '../schema';

const Profile = ({
  entity,
  entityInfos,
  onActivityLogSubmitHandler,
  options,
}) => {
  const { usersInGroup = [], stationsInGroup = [] } = options;
  return (
    <EntityProfile
      entity={entity}
      entityInfos={entityInfos}
      entitySchema={entitySchema}
      onActivityLogSubmitHandler={onActivityLogSubmitHandler}
    >
      <div>
        <h4 className="title is-4">
          <span className="icon">
            <i className="mdi mdi-account-supervisor" />
          </span>
          &nbsp;Users ({usersInGroup.length})
        </h4>
        <ul>
          {usersInGroup.map((user) => {
            return (
              <li key={user.id}>
                {user.name} - {user.email}
              </li>
            );
          })}
        </ul>
      </div>
      <div className="mt-4">
        <h4 className="title is-4">
          <span className="icon">
            <i className="mdi mdi-signal-variant" />
          </span>
          &nbsp;Stations ({stationsInGroup.length})
        </h4>
        <ul>
          {stationsInGroup.map((station) => {
            return (
              <li key={station.id}>
                #{station.serialNumber} - {station.name} (
                {useFormatAddress(station.address)})
              </li>
            );
          })}
        </ul>
      </div>
    </EntityProfile>
  );
};

export default Profile;
